import React from "react";
import { getTechnologyLogo } from "./technologyLogo";

type TechnologyIconProps = {
    // The integration type's `value` (e.g. "earth_ranger") — the logo lookup key.
    typeValue?: string;
    // The technology's display name; its first letter is the no-logo fallback.
    typeName?: string;
    // Box metrics (size, and text size for the letter). The box is the same for
    // both branches so the surrounding layout doesn't shift between them.
    boxClassName: string;
    // Logo metrics only. Grid cards zoom-crop (a box smaller than the image plus
    // object-cover); headers show the logo whole with object-contain.
    imgClassName: string;
};

// A technology's logo where one exists, and its first letter where none does.
// Single source of truth for that choice: the provider grid, the Connection
// header, and the flow map's account cards all render through this, so adding a
// PNG (or hitting a technology that has none) behaves the same everywhere.
//
// The letter carries the pale-green circle; a logo renders on bare background so
// transparent artwork isn't tinted.
const TechnologyIcon = ({ typeValue, typeName, boxClassName, imgClassName }: TechnologyIconProps) => {
    const logo = getTechnologyLogo(typeValue);
    const letter = (typeName || "").trim().charAt(0).toUpperCase();
    // Neither a logo nor a name to take a letter from: render nothing rather than
    // an empty circle. Headers that previously showed nothing keep doing so.
    if (!logo && !letter) return null;
    return (
        <span
            aria-hidden="true"
            className={`flex-none rounded-full overflow-hidden flex items-center justify-center leading-none ${
                logo ? "" : "bg-teal-t20 text-ui-text-primary-text font-bold"} ${boxClassName}`}>
            {logo
                ? <img src={logo} alt="" aria-hidden="true" className={imgClassName} />
                : letter}
        </span>
    );
};

export default TechnologyIcon;
